export default (node) => {
  $('#hover-node-card .card-header').text(node.name)

  const fileData = node.data.fileData || ''
  const carouselItemTitle = node.data.carouselItemTitle || ''
  const carouselItemSubtitle = node.data.carouselItemSubtitle || ''
  const imageClickDestinationLink = node.data.imageClickDestinationLink || ''

  let html = ''

  if (Object.values(fileData).length === 3) {
    const filePath = fileData.path || ''
    const fileName = fileData.filename || ''

    if (filePath && fileName) {
      const imgSource = 'https://192.168.10.60/xerochat/' + filePath + fileName
      if (imageClickDestinationLink) {
        html += `<p><img class="img-fluid" src="${imgSource}" /></p>`
      } else {
        html += `<p><a href="${imageClickDestinationLink}" target="_blank"><img class="img-fluid" src="${imgSource}" /></a></p>`
      }
    }
  }
  
  if (carouselItemTitle) {
    html += `<p><strong>Title:</strong> ${carouselItemTitle}</p>`
  }
  
  if (carouselItemSubtitle) {
    html += `<p><strong>Subtitle:</strong> ${carouselItemSubtitle}</p>`
  }

  if (! carouselItemTitle && ! carouselItemSubtitle) {
    $('#hover-node-card .card-body').html('')
  } else {
    $('#hover-node-card .card-body').html(html)
  }
}